import classNames from 'classnames';
import React from 'react';
import styles from './Tab.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
}

const Tab = (props: Props) => {
  const { isActive = false, children, onClick, ...rest } = props;
  const tabClass = classNames(styles.container, {
    [styles.isActive]: isActive,
  });
  const height = 40;

  const baseTabStyle: React.CSSProperties = {
    height,
  };

  const tabStyle: React.CSSProperties = isActive
    ? baseTabStyle
    : {
        ...baseTabStyle,
      };

  return (
    <div {...rest} className={tabClass} style={tabStyle} onClick={onClick}>
      {children}
    </div>
  );
};

export default Tab;
